import {ColorSchemeType} from 'platform/components';
import {match} from 'ts-pattern';

import {always, isNil, toLower} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export interface MazdaItemTypeFlag {
  label: string;
  colorScheme: ColorSchemeType;
}

export const getMazdaItemTypeFlag = (type: string | Nullish) =>
  match<string | Nullish, MazdaItemTypeFlag | null>(isNil(type) ? type : toLower(type))
    .when(isNil, always(null))
    .with('part', always({label: i18n.t('entity.claimType.labels.part'), colorScheme: 'blue'}))
    .with(
      'labour',
      always({label: i18n.t('entity.calculationType.labels.labour'), colorScheme: 'green'})
    )
    .with(
      'sublet',
      always({label: i18n.t('entity.orderIntegration.labels.sublet'), colorScheme: 'neutral'})
    )
    .otherwise((value) => ({label: value, colorScheme: 'neutral'}));
